"use strict";

var _slicedToArray = require("/codebuild/output/src213846038/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/slicedToArray.js");

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);

  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }

  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useNotifications = exports.NotificationsProvider = exports.NotificationsContext = exports.NotificationsType = void 0;

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var React = __importStar(require("react"));

var NotificationsType;

(function (NotificationsType) {
  NotificationsType["AddToCart"] = "add-to-cart";
})(NotificationsType || (exports.NotificationsType = NotificationsType = {}));

exports.NotificationsContext = React.createContext({});

var NotificationsProvider = function NotificationsProvider(_ref) {
  var children = _ref.children,
      defaultNotfications = _ref.notifications;

  var _React$useState = React.useState(defaultNotfications),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      notifications = _React$useState2[0],
      setNotifications = _React$useState2[1];

  var timerRef = React.useRef();
  var addNotification = React.useCallback(function (notification) {
    clearTimeout(timerRef.current);
    if (notification.id === undefined) notification.id = new Date().getTime();
    setNotifications([notification]);

    if (notification.timeOut !== undefined && notification.timeOut > 0) {
      timerRef.current = setTimeout(function () {
        removeNotification();
      }, notification.timeOut);
    }
  }, [notifications, setNotifications]);
  var removeNotification = React.useCallback(function () {
    clearTimeout(timerRef.current);
    setNotifications([]);
  }, [notifications, setNotifications]);
  return (0, jsx_runtime_1.jsx)(exports.NotificationsContext.Provider, {
    value: {
      notifications: notifications,
      addNotification: addNotification,
      removeNotification: removeNotification
    },
    children: children
  });
};

exports.NotificationsProvider = NotificationsProvider;
exports.default = exports.NotificationsContext;

function useNotifications() {
  return React.useContext(exports.NotificationsContext);
}

exports.useNotifications = useNotifications;